import { ArrowNavigation } from '#/components/ArrowNavigation/ArrowNavigation';
import type { CarouselState } from '#/components/Carousel/CarouselState';
import { DotNavigationButton } from '#/components/DotNavigationButton/DotNavigationButton';
import { useI18n } from '#/i18n/hooks/useI18n';
import { range } from '#/utils/functional/array/range';

import {
  SearchHitCarouselNavigationDotsInnerHolder,
  SearchHitCarouselNavigationDotsOuterHolder,
} from './SearchHitCarouselNavigation.styled';

type Props = {
  carouselState: CarouselState;
};

export function SearchHitCarouselNavigation({ carouselState }: Props) {
  const { i18n } = useI18n();

  const { currentPage, pageCount, goToPage, goToPreviousPage, goToNextPage } =
    carouselState;

  return (
    <nav>
      <ArrowNavigation
        nextPage={goToNextPage}
        prevPage={goToPreviousPage}
        current={currentPage}
        total={pageCount}
      />

      {pageCount > 1 && (
        <SearchHitCarouselNavigationDotsOuterHolder>
          <SearchHitCarouselNavigationDotsInnerHolder>
            {range(pageCount).map((index) => (
              <DotNavigationButton
                key={index}
                onClick={() => goToPage(index)}
                $isActive={index === currentPage}
                title={`${i18n('Go to page')} ${index + 1}`}
              />
            ))}
          </SearchHitCarouselNavigationDotsInnerHolder>
        </SearchHitCarouselNavigationDotsOuterHolder>
      )}
    </nav>
  );
}
